import React from "react";
import "./CardEducation.css"


const CardEducation = ({study, name, detail}) => {
    return (
   

        <div className="cardEducation">
            <div className="icon">
                <h3>{study}</h3>
            </div>

            <div className="content">
                <h3>{name}</h3>
                <p>{detail} </p>
            </div>
        </div>
           


        
    );
};

export default CardEducation;